import { mapActions, mapGetters, mapState } from 'vuex';
import { get, isEmpty } from 'lodash';
import {
  enablePriceOptimisation,
  displayPriceOptimisationButtonOnlyForPriceList,
} from '@enums/feature-flags';
import workpackagePeriodTypes from '@enums/workpackage-period-types';

/**
 * Shared mixin for engine control components (engine-controls, tsg-engine-controls-header,
 * navbar-engine-controls). Provides common Vuex mappings, computed properties, and the
 * actions that all three components use identically.
 *
 * Components consuming this mixin are responsible for their own canRunOptimisation and
 * crossElasticityButtonTooltipMsg computeds, as those differ per usage context.
 */
const mixin = {
  data() {
    return {
      enablePriceOptimisation,
      displayPriceOptimisationButtonOnlyForPriceList,
      get,
    };
  },

  computed: {
    ...mapState('filters', ['scenario']),
    ...mapState('workpackages', ['selectedWorkpackage']),
    ...mapState('gridView', [
      'calculatingScenarioResults',
      'calculatingScenarioElasticityResults',
      'recalculatingAll',
      'lastTriggeredInfo',
      'isLastTriggeredLoading',
    ]),
    ...mapGetters('context', ['isWholesaleManager', 'isWholesaleAnalyst', 'isAdminLoggedIn']),
    ...mapGetters('gridView', ['hasUnsavedKpiResults']),

    /** Whether the current user can perform engine actions. */
    isEditable() {
      return this.isAdminLoggedIn || (!this.isWholesaleManager && !this.isWholesaleAnalyst);
    },

    /** Whether the selected workpackage uses weekly periods (blocks cross-elasticity). */
    isWeeklyWorkpackage() {
      return this.selectedWorkpackage.workpackagePeriodType === workpackagePeriodTypes.weekly;
    },

    /** Whether the selected workpackage has AO extracts configured. */
    hasAOExtracts() {
      return !isEmpty(get(this.selectedWorkpackage, 'aoExtracts', []));
    },
  },

  methods: {
    ...mapActions('gridView', ['handleRecalculate', 'handleCrossElasticityOptimisation']),
  },
};

export default mixin;
